import React from 'react';
import { Box, Typography } from '@mui/material';
import FavoriteButton from './FavoriteButton';

/** Заголовок с кнопкой «избранное» справа от названия */
export default function CardTitleRow({
  type,
  entityId,
  children,
  titleSx = {},
  titleClassName = 'card-title',
  titleVariant,
  gutterBottom = false,
  sx = {},
}) {
  const isCardTitle = !titleVariant;

  return (
    <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 0.5, minWidth: 0, ...sx }}>
      <Typography
        variant={titleVariant}
        gutterBottom={gutterBottom}
        className={titleClassName}
        sx={{
          flex: 1,
          minWidth: 0,
          ...(isCardTitle ? { lineHeight: 1.25, fontSize: '0.85rem' } : {}),
          ...titleSx,
        }}
      >
        {children}
      </Typography>
      {entityId ? <FavoriteButton type={type} entityId={entityId} inline /> : null}
    </Box>
  );
}
